export function isNonEmptyArray(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
